import React from 'react';
import {
  configure_which_deliverables_str,
  Deliverables_str,
  Include_imessage, Instead_accessing_redirect,
  iOS_options,
  Redirect_keyboard_to_bank,
} from '../utils/DictionaryManagementUtils';
import FullPagePanel from '../components/PanelsComponents/General/FullPagePanel';
import Title from '../components/PanelsComponents/Text/Title';
import { LocStr } from '../utils/Utils';
import SwitcherPanel from '../components/PanelsComponents/Buttons/SwitcherPanel';
import Paragraph from '../components/PanelsComponents/Text/Paragraph';

//= ========================================================================

const Panel_E01_Deliverables = ({
  onStepPressed,
  onConfigChanged,
  globJSON,
  selectedScreen,
  language,
}) => {
  const { deliverables } = globJSON.configurations;
  const onValueChanged = (key, value) => {
    deliverables.deliverables[key] = value;
    onConfigChanged();
  };

  return (
    <FullPagePanel
      globJSON={globJSON}
      selectedScreen={selectedScreen}
      onConfigChanged={onConfigChanged}
      onStepPressed={onStepPressed}
      panelHeadline={Deliverables_str}
      paragraph={configure_which_deliverables_str}
      tooltipsTitles={deliverables.screens_ordering}
      disableEditElements
      language={language}
      paddingVertical={25}
    >
      <Title isBold>{LocStr(iOS_options, language)}</Title>
      <SwitcherPanel
        text={Include_imessage}
        value={deliverables.deliverables.iMsg_enabled}
        onValueChanged={(value) => {
          onValueChanged('iMsg_enabled', value);
        }}
      />
      <SwitcherPanel
        text={Redirect_keyboard_to_bank}
        value={deliverables.deliverables.redirect_from_keyboard_enabled}
        onValueChanged={(value) => {
          onValueChanged('redirect_from_keyboard_enabled', value);
        }}
      />
      <Paragraph>{Instead_accessing_redirect}</Paragraph>
    </FullPagePanel>
  );
};

export default Panel_E01_Deliverables;
